import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12 p-md-4" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_11 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_12 = { class: "kn-list-item-text" }
const _hoisted_13 = { class: "kn-list-item-text-secondary" }
const _hoisted_14 = { class: "p-mt-4" }
const _hoisted_15 = { class: "p-d-flex p-jc-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Message = _resolveComponent("Message")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Column = _resolveComponent("Column")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ColorPicker = _resolveComponent("ColorPicker")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Sidebar = _resolveComponent("Sidebar")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          style: _ctx.tabViewDescriptor.style.card
        }, {
          content: _withCtx(() => [
            (_ctx.kpi.threshold.usedByKpi)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  severity: "info",
                  closable: false,
                  style: _ctx.tresholdTabDescriptor.styles.message
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDefinition.thresholdReused')) + " ", 1),
                    _createVNode(_component_Button, {
                      label: _ctx.$t('kpi.kpiDefinition.clone'),
                      onClick: _ctx.cloneExistingThreshold
                    }, null, 8, ["label", "onClick"])
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true),
            _createVNode("form", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_InputText, {
                    id: "name",
                    class: ["kn-material-input", { 'p-invalid': _ctx.v$.threshold.name.$invalid && _ctx.v$.threshold.name.$dirty }],
                    type: "text",
                    maxLength: "100",
                    modelValue: _ctx.v$.threshold.name.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.threshold.name.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.threshold.name.$touch())),
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
                    "data-test": "name-input"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.threshold.name,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    id: "description",
                    class: ["kn-material-input", { 'p-invalid': _ctx.v$.threshold.description.$invalid && _ctx.v$.threshold.description.$dirty }],
                    type: "text",
                    maxLength: "500",
                    modelValue: _ctx.v$.threshold.description.$model,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.threshold.description.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.threshold.description.$touch())),
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched'))),
                    "data-test": "description-input"
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.threshold.description,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_Dropdown, {
                    id: "type",
                    class: "kn-material-input",
                    modelValue: _ctx.threshold.typeId,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.threshold.typeId = $event)),
                    options: _ctx.thresholdTypeList,
                    optionLabel: "translatedValueName",
                    optionValue: "valueId",
                    onChange: _ctx.setTypeCd
                  }, {
                    option: _withCtx((slotProps) => [
                      _createVNode("span", null, _toDisplayString(slotProps.option.translatedValueName), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "onChange"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.type')), 1)
                ])
              ])
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ProgressBar, {
                  key: 1,
                  mode: "indeterminate",
                  class: "kn-progress-bar",
                  "data-test": "progress-bar"
                }))
              : _createCommentVNode("", true),
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 2,
                  value: _ctx.kpi.threshold.thresholdValues,
                  loading: _ctx.loading,
                  editMode: "cell",
                  class: "p-datatable-sm kn-table",
                  dataKey: "id",
                  responsiveLayout: "stack",
                  breakpoint: "960px",
                  onRowReorder: _ctx.setPositionOnReorder,
                  "data-test": "messages-table",
                  onCellEditComplete: _ctx.onCellEditComplete
                }, {
                  footer: _withCtx(() => [
                    _createVNode(_component_Button, {
                      label: _ctx.$t('kpi.kpiDefinition.addNewThreshold'),
                      class: "p-button-link",
                      style: _ctx.tresholdTabDescriptor.styles.table.footer,
                      onClick: _ctx.addNewThresholdItem
                    }, null, 8, ["label", "style", "onClick"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      rowReorder: true,
                      headerStyle: "width: 3rem",
                      reorderableColumn: false
                    }),
                    _createVNode(_component_Column, {
                      field: "label",
                      header: _ctx.$t('common.label')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputText, {
                          style: _ctx.tresholdTabDescriptor.styles.input,
                          modelValue: slotProps.data['label'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['label'] = $event),
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "minValue",
                      header: _ctx.$t('kpi.kpiDefinition.min')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputText, {
                          style: _ctx.tresholdTabDescriptor.styles.input,
                          modelValue: slotProps.data['minValue'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['minValue'] = $event),
                          type: "number",
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "includeMin",
                      header: _ctx.$t('kpi.kpiDefinition.minInclude')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Checkbox, {
                          modelValue: slotProps.data['includeMin'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['includeMin'] = $event),
                          binary: true,
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "maxValue",
                      header: _ctx.$t('kpi.kpiDefinition.max')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_InputText, {
                          style: _ctx.tresholdTabDescriptor.styles.input,
                          modelValue: slotProps.data['maxValue'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['maxValue'] = $event),
                          type: "number",
                          onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "includeMax",
                      header: _ctx.$t('kpi.kpiDefinition.maxInclude')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Checkbox, {
                          modelValue: slotProps.data['includeMax'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['includeMax'] = $event),
                          binary: true,
                          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      field: "severityId",
                      header: "Severity"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Dropdown, {
                          modelValue: slotProps.data['severityId'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['severityId'] = $event),
                          style: _ctx.tresholdTabDescriptor.styles.input,
                          options: _ctx.severityOptions,
                          optionLabel: "valueCd",
                          optionValue: "valueId",
                          onChange: ($event: any) => (_ctx.setSeverityCd($event, slotProps.data))
                        }, {
                          option: _withCtx((slotProps) => [
                            _createVNode("span", null, _toDisplayString(slotProps.option.valueCd), 1)
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "style", "options", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "color",
                      header: _ctx.$t('kpi.kpiDefinition.color')
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_ColorPicker, {
                          modelValue: slotProps.data['color'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['color'] = $event),
                          format: "hex",
                          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _withDirectives(_createVNode(_component_InputText, {
                          class: "kn-material-input",
                          style: _ctx.tresholdTabDescriptor.styles.colorInput,
                          modelValue: slotProps.data['color'],
                          "onUpdate:modelValue": ($event: any) => (slotProps.data['color'] = $event),
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["style", "modelValue", "onUpdate:modelValue"]), [
                          [
                            _directive_tooltip,
                            slotProps.data['color'],
                            void 0,
                            { top: true }
                          ]
                        ])
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, {
                      header: "",
                      style: {"text-align":"right"}
                    }, {
                      header: _withCtx(() => [
                        _createVNode(_component_Button, {
                          label: _ctx.$t('kpi.kpiDefinition.thresholdsListTitle'),
                          class: "p-button-link",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.thresholdListVisible = true))
                        }, null, 8, ["label"])
                      ]),
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_Button, {
                          icon: "pi pi-trash",
                          class: "p-button-link",
                          onClick: ($event: any) => (_ctx.deleteThresholdItemConfirm(slotProps.index))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "loading", "onRowReorder", "onCellEditComplete"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Sidebar, {
      class: "mySidebar",
      visible: _ctx.thresholdListVisible,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (_ctx.thresholdListVisible = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('kpi.kpiDefinition.thresholdsListTitle')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Listbox, {
          class: "kn-list--column",
          options: _ctx.thresholdsList,
          filter: true,
          filterPlaceholder: _ctx.$t('common.search'),
          filterMatchMode: "contains",
          filterFields: _ctx.tabViewDescriptor.filterFields,
          emptyFilterMessage: _ctx.$t('common.info.noDataFound'),
          onChange: _ctx.confirmToLoadThreshold
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("span", null, _toDisplayString(slotProps.option.name), 1),
                _createVNode("span", _hoisted_13, _toDisplayString(slotProps.option.description), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["options", "filterPlaceholder", "filterFields", "emptyFilterMessage", "onChange"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      class: "kn-dialog--toolbar--primary importExportDialog",
      visible: _ctx.overrideDialogVisible,
      footer: "footer",
      header: _ctx.$t('kpi.kpiDefinition.reusedTitle'),
      closable: false,
      modal: ""
    }, {
      footer: _withCtx(() => [
        _createVNode("div", _hoisted_15, [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            label: _ctx.$t('common.cancel'),
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.overrideDialogVisible = false))
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            label: _ctx.$t('kpi.kpiDefinition.useIt'),
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.cloneSelectedThreshold('use')))
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary",
            label: _ctx.$t('kpi.kpiDefinition.clone'),
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.cloneSelectedThreshold('clone')))
          }, null, 8, ["label"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('kpi.kpiDefinition.thresholdReused')), 1)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}